import { uniqBy } from 'lodash';
import { isValidAppLink } from 'hooks/useAppLink';
import { sortAccordingToDatetime } from 'utils/sort';
import * as types from '../../../actions/types';
const initialState = {
    error: null,
    isFetching: {},
    spaceNotifications: {},
    spacePage: {},
    spacePageCount: {},
};
const filterValidAppLinks = (items) => items.map((item) => ({
    ...item,
    // Remove any appLinks that aren’t valid
    data: item.data
        ? {
            ...item.data,
            appLink: 'appLink' in item.data &&
                item.data.appLink &&
                isValidAppLink(item.data.appLink)
                ? item.data.appLink
                : undefined,
        }
        : undefined,
}));
const notifications = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGGED_OUT: {
            return initialState;
        }
        case types.GET_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                error: null,
                isFetching: {
                    ...state.isFetching,
                    [action.extra.spaceId]: true,
                },
            };
        case types.GET_NOTIFICATIONS_SUCCESS: {
            const isNewArray = !state.spaceNotifications[action.extra.spaceId] ||
                !action.payload.items[0] ||
                !state.spaceNotifications[action.extra.spaceId]?.[0] ||
                action.payload.items[0].id !==
                    state.spaceNotifications[action.extra.spaceId]?.[0]?.id;
            if (action.payload.paging.page === 1) {
                if (!isNewArray) {
                    // Nothing has changed, use the cache
                    return {
                        ...state,
                        error: null,
                        isFetching: {
                            ...state.isFetching,
                            [action.extra.spaceId]: false,
                        },
                    };
                }
                // The notifications are different wipe the cache
                return {
                    ...state,
                    spaceNotifications: {
                        ...state.spaceNotifications,
                        [action.extra.spaceId || -1]: filterValidAppLinks(action.payload.items),
                    },
                    spacePage: {
                        ...state.spacePage,
                        [action.extra.spaceId || -1]: action.payload.paging.page,
                    },
                    spacePageCount: {
                        ...state.spacePageCount,
                        [action.extra.spaceId || -1]: action.payload.paging.pageCount,
                    },
                    error: null,
                    isFetching: {
                        ...state.isFetching,
                        [action.extra.spaceId]: false,
                    },
                };
            }
            // New page has loaded, append to the end of the cache
            return {
                ...state,
                spacePage: {
                    ...state.spacePage,
                    [action.extra.spaceId || -1]: action.payload.paging.page,
                },
                spacePageCount: {
                    ...state.spacePageCount,
                    [action.extra.spaceId || -1]: action.payload.paging.pageCount,
                },
                error: null,
                isFetching: {
                    ...state.isFetching,
                    [action.extra.spaceId]: false,
                },
                spaceNotifications: {
                    ...state.spaceNotifications,
                    [action.extra.spaceId || -1]: uniqBy([
                        ...(state.spaceNotifications[action.extra.spaceId || -1] || []),
                        ...filterValidAppLinks(action.payload.items),
                    ], (item) => item.id).sort(sortAccordingToDatetime),
                },
            };
        }
        case types.GET_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                error: true,
                isFetching: {
                    ...state.isFetching,
                    [action.extra.spaceId]: false,
                },
            };
        default:
            return state;
    }
};
export default notifications;
